import { sendRequest } from "../ApiRequest";

const DEFAULT_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const requestCache = new Map();

const buildCacheKey = (method, url, data, options) => {
  const paramsKey = options?.params ? JSON.stringify(options.params) : "";
  const dataKey = data ? JSON.stringify(data) : "";
  return `${method}:${url}:${paramsKey}:${dataKey}`;
};

const normalizeOptions = (options = {}) => {
  const cloned = { ...options };
  delete cloned.cacheKey;
  delete cloned.cacheDuration;
  delete cloned.skipCache;
  return cloned;
};

export const sendCachedRequest = async (
  method,
  url,
  data = null,
  options = {}
) => {
  const {
    cacheKey,
    cacheDuration = DEFAULT_CACHE_DURATION,
    skipCache = false,
  } = options;

  if (skipCache || cacheDuration <= 0) {
    return sendRequest(method, url, data, normalizeOptions(options));
  }

  const key = cacheKey || buildCacheKey(method, url, data, options);
  const now = Date.now();
  const cachedEntry = requestCache.get(key);

  if (cachedEntry) {
    if (cachedEntry.data && now - cachedEntry.timestamp < cacheDuration) {
      return cachedEntry.data;
    }
    if (cachedEntry.promise) {
      return cachedEntry.promise;
    }
  }

  const pendingPromise = sendRequest(
    method,
    url,
    data,
    normalizeOptions(options)
  )
    .then((response) => {
      requestCache.set(key, { data: response, timestamp: Date.now() });
      return response;
    })
    .catch((error) => {
      requestCache.delete(key);
      throw error;
    });

  requestCache.set(key, { promise: pendingPromise, timestamp: now });
  return pendingPromise;
};

export const clearCachedRequest = (cacheKey) => {
  if (cacheKey) {
    requestCache.delete(cacheKey);
  }
};



